import {createBrowserHistory} from "history";

let History = createBrowserHistory();
import Submenu from '../Navigation/Submenu/Submenu.js';
import Page from "../Layout/Page/Page";
import Section from "../Sections/Section";
import Modules from "../../../modules/Modules";
import LangSwitcher from "../Header/LangSwitcher/LangSwitcher";

const Router = {
    debug: false,
    url: '',
    path: '',
    pathArray: [],
    page: '',
    section: '',
    params: '',

    init() {

        if (window.parent.editorGateway !== undefined) return;

        History.listen(({action, location}) => {
            // console.log(action, location)
            this.parseUrl(location.state);
        });

        this.bind();
        this.parseUrl()
    },

    bind() {

        const components = $('[component="Header"], [component="Page"]').not('.sitelab');
        let anchors = components.find('a').not('.not-root, [popup], [router="false"], [href^="http"], [href^="mailto"], [href^="tel"], [target="_blank"]');

        if (this.debug) {
            console.log('Router.bindAnchors() ---------------------------------');
            console.log(anchors);
        }

        anchors.click((evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            const el = $(evt.currentTarget);

            const url = el.attr('href');
            let title = el.attr('title');
            title = title ? title.replace('<small>', '').replace('</small>', '').replace('<br>', ' ') : '';
            History.push(url, {title: title});
        })

    },

    parseUrl(state) {
        if (window.parent.editorGateway !== undefined) return;
        // console.log('parse URL:', window.location.href.replace(WEB_ROOT+"/", ""));

        this.goFirstTime = this.page === undefined || this.page === "";

        const origin = window.location.origin;
        this.url = window.location.href.replace(origin, "");
        this.path = window.location.pathname;
        this.search = window.location.search;
        this.hash = window.location.hash;
        this.pathArray = this.path.substring(1).split("/");

        this.page = this.pathArray[0];
        this.section = this.pathArray[1];
        this.sectionUrl = this.section ? this.page + "/" + this.section : null;
        this.params = this.pathArray[2];

        Page.setByUrl(this.page);

        if (this.goFirstTime) {
            setTimeout(() => {
                this.setByUrl();
            }, 300)
        } else {
            this.setByUrl();
        }

        if (this.debug) {
            console.log('*** Router.parseUrl -----------------------------');
            console.log('this.url', this.url);
            console.log('this.path', this.path);
            console.log('this.pathArray', this.pathArray);
            console.log('this.search', this.search);
            console.log('this.hash', this.hash);
            console.log('----------------------')
            console.log('this.page', this.page);
            console.log('this.sectionUrl', this.sectionUrl);
            console.log('this.params', this.params);
            console.log('----------------------')
        }

        this.sendGaPageView();
    },

    setByUrl() {
        // console.log('setByUrl **************************************')
        if (this.search) Modules.setByUrl(this.path, this.search);
        Section.setByUrl();
        Submenu.select(this.sectionUrl);
        LangSwitcher.setByUrl();
        if (this.params) {
            ModuleAccordion.setByUrl(this.params);
        }
    },


    //Manually trigger pageView on GA
    sendGaPageView: function () {
        if (!window.ga) return;
        ga('gtm1.set', 'page', location.pathname);
        ga('gtm1.send', 'pageview');

        // if (!window.dataLayer) return;
        // if (!this.debug) {
        //     console.log('--- Router.sendGaPageView() ---');
        //     console.log('::dataLayer');
        //     console.log(window.dataLayer);
        // }
        //
        // window.dataLayer.push({
        //     event: 'pageview',
        //     page: {
        //         path: Router.currentRoot.url,
        //         title: Router.currentRoot.title,
        //     }
        // });
    },

    route(url, state) {

        if (this.debug) {
            console.log('*** Router.route -----------------------------');
            console.log(url, url);
            console.log(state, state);
        }

        History.push(url, state);
    },

    back() {
        History.back();
    },

}

export default Router